import * as api from '../../../clients/benutzerverwaltung';

import {Action} from '@ngrx/store';

export const POST_BENUTZER_EINLADEN_ADMIN = '[BenutzerverwaltungModul] PostBenutzerEinladenAdmin laden';
export const POST_BENUTZER_EINLADEN_ADMIN_AUSFUEHREN = '[BenutzerverwaltungModul] PostBenutzerEinladenAdmin ausführen';
export const POST_BENUTZER_EINLADEN_ADMIN_ERFOLGREICH = '[BenutzerverwaltungModul] PostBenutzerEinladenAdmin laden erfolgreich';
export const POST_BENUTZER_EINLADEN_ADMIN_FEHLER = '[BenutzerverwaltungModul] PostBenutzerEinladenAdmin Ladefehler';
export const POST_BENUTZER_EINLADEN_ADMIN_NICHT_AUSGEFUEHRT = '[BenutzerverwaltungModul] PostBenutzerEinladenAdmin nicht ausgeführt (evtl. Offline)';


export class PostBenutzerEinladenAdminAction implements Action {
    readonly type = POST_BENUTZER_EINLADEN_ADMIN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEinladenAdminAusfuehrenAction implements Action {
    readonly type = POST_BENUTZER_EINLADEN_ADMIN_AUSFUEHREN;
        constructor(public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEinladenAdminErfolgreichAction implements Action {
    readonly type = POST_BENUTZER_EINLADEN_ADMIN_ERFOLGREICH;
        constructor(public payload: api.BenutzerIdentifier, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEinladenAdminFehlerAction implements Action {
    readonly type = POST_BENUTZER_EINLADEN_ADMIN_FEHLER;
        constructor(public payload: any, public benutzerRequest: api.BenutzerRequest, public optPayload: any = null) {}
    }
export class PostBenutzerEinladenAdminNichtAusgefuehrtAction implements Action {
    readonly type = POST_BENUTZER_EINLADEN_ADMIN_NICHT_AUSGEFUEHRT;
        constructor(public optPayload: any = null) {}
    }
    

export type BenutzerverwaltungCommandBenutzerEinladenAdminActions =
    PostBenutzerEinladenAdminAction
    | PostBenutzerEinladenAdminAusfuehrenAction
    | PostBenutzerEinladenAdminErfolgreichAction
    | PostBenutzerEinladenAdminFehlerAction
    | PostBenutzerEinladenAdminNichtAusgefuehrtAction
    ;
